/* ==========================================================================
   Kuba PDP · mídia — players de áudio (graves / A-B / versões), hero com
   parallax e gráfico desenhado no scroll.
   Vanilla, idempotente (o editor de temas recarrega seções).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__kbMediaLoaded) { window.__kbMediaInit && window.__kbMediaInit(); return; }
  window.__kbMediaLoaded = true;

  var players = [];

  function fmt(s) {
    var v = Math.max(0, Math.floor(s || 0));
    return Math.floor(v / 60) + ':' + String(v % 60).padStart(2, '0');
  }

  /* ---------- Player (n faixas, troca mantém a posição) ---------- */
  function Player(root) {
    this.root = root;
    this.tracks = [].slice.call(root.querySelectorAll('[data-kb-track]'));
    if (!this.tracks.length) this.tracks = [root]; // faixa única: data-src no próprio player
    this.playBtn = root.querySelector('[data-kb-play]');
    this.glyph = root.querySelector('[data-kb-glyph]');
    this.seek = root.querySelector('[data-kb-seek]');
    this.bars = [].slice.call(root.querySelectorAll('.kb-wave rect'));
    this.time = root.querySelector('[data-kb-time]');
    this.status = root.querySelector('[data-kb-status]');
    this.caption = root.querySelector('[data-kb-caption]');
    this.knob = root.querySelector('[data-kb-knob]');
    this.empty = root.getAttribute('data-empty') || 'Áudio pendente — envie nos Tweaks';
    this.idx = parseInt(root.getAttribute('data-kb-default') || '0', 10) || 0;
    if (this.idx >= this.tracks.length) this.idx = 0;
    this.audio = {};
    this.playing = false;
    this.t = 0;
    this.dur = 0;
    this.bind();
    this.paint();
  }

  Player.prototype.url = function (i) {
    var el = this.tracks[i];
    return el ? (el.getAttribute('data-src') || '').trim() : '';
  };

  Player.prototype.el = function (i) {
    var url = this.url(i);
    if (!url) return null;
    var cur = this.audio[i];
    if (!cur || cur.getAttribute('data-src') !== url) {
      if (cur) cur.pause();
      var a = new Audio();
      var self = this;
      a.preload = 'none';
      a.setAttribute('data-src', url);
      a.src = url;
      a.addEventListener('timeupdate', function () {
        if (self.idx !== i) return;
        self.t = a.currentTime; self.dur = a.duration || 0; self.paint();
      });
      a.addEventListener('loadedmetadata', function () { if (self.idx === i) { self.dur = a.duration || 0; self.paint(); } });
      a.addEventListener('ended', function () { if (self.idx === i) { self.playing = false; self.t = 0; self.paint(); } });
      this.audio[i] = a;
    }
    return this.audio[i];
  };

  Player.prototype.pauseAll = function () {
    var self = this;
    Object.keys(this.audio).forEach(function (k) { self.audio[k].pause(); });
  };

  Player.prototype.stop = function () {
    if (!this.playing) return;
    this.pauseAll();
    this.playing = false;
    this.paint();
  };

  Player.prototype.toggle = function () {
    var a = this.el(this.idx);
    if (!a) return;
    if (this.playing) { a.pause(); this.playing = false; this.paint(); return; }
    players.forEach(function (p) { p.stop(); });
    this.pauseAll();
    try { a.currentTime = this.t || 0; } catch (e) {}
    var self = this;
    var p = a.play();
    if (p && p.catch) p.catch(function () { self.playing = false; self.paint(); });
    this.playing = true;
    this.paint();
  };

  Player.prototype.pick = function (i) {
    if (i === this.idx) return;
    var prev = this.audio[this.idx];
    var pos = prev ? prev.currentTime : (this.t || 0);
    if (prev) prev.pause();
    this.idx = i;
    this.t = pos;
    var next = this.el(i);
    var self = this;
    if (next) {
      var apply = function () { try { next.currentTime = Math.min(pos, next.duration || pos); } catch (e) {} };
      apply();
      this.dur = next.duration || 0;
      if (this.playing) {
        next.addEventListener('loadedmetadata', apply, { once: true });
        var p = next.play();
        if (p && p.catch) p.catch(function () { self.playing = false; self.paint(); });
      }
    } else {
      this.playing = false;
      this.dur = 0;
    }
    this.paint();
  };

  Player.prototype.seekTo = function (frac) {
    var a = this.el(this.idx);
    var dur = (a && a.duration) || this.dur || 0;
    if (!a || !dur) return;
    var t = Math.max(0, Math.min(dur, frac * dur));
    try { a.currentTime = t; } catch (e) {}
    this.t = t;
    this.paint();
  };

  Player.prototype.paint = function () {
    var has = !!this.url(this.idx);
    var dur = this.dur || 0;
    var prog = dur ? Math.min(1, (this.t || 0) / dur) : 0;
    var n = this.bars.length;
    this.bars.forEach(function (r, i) { r.classList.toggle('is-on', i / n < prog); });
    if (this.glyph) this.glyph.textContent = this.playing ? '❙❙' : '▶';
    if (this.playBtn) this.playBtn.setAttribute('aria-pressed', this.playing ? 'true' : 'false');
    var label = has ? (fmt(this.t) + ' / ' + (dur ? fmt(dur) : '0:00')) : '0:00 / 0:00';
    if (this.time) this.time.textContent = label;
    if (this.seek) this.seek.setAttribute('aria-valuetext', label);
    var tr = this.tracks[this.idx];
    if (this.status) this.status.textContent = has ? (tr.getAttribute('data-status') || '') : this.empty;
    if (this.caption && tr) this.caption.textContent = tr.getAttribute('data-caption') || '';
    var idx = this.idx;
    this.tracks.forEach(function (b, i) {
      if (b.hasAttribute('data-kb-track')) {
        b.classList.toggle('is-on', i === idx);
        b.setAttribute('aria-pressed', i === idx ? 'true' : 'false');
      }
    });
    if (this.knob) this.knob.style.transform = 'translateX(' + (idx * 100) + '%)';
  };

  Player.prototype.bind = function () {
    var self = this;
    if (this.playBtn) this.playBtn.addEventListener('click', function () { self.toggle(); });
    this.tracks.forEach(function (b, i) {
      if (b.hasAttribute('data-kb-track')) b.addEventListener('click', function () { self.pick(i); });
    });
    if (this.seek) {
      this.seek.addEventListener('click', function (e) {
        var r = self.seek.getBoundingClientRect();
        if (r.width) self.seekTo((e.clientX - r.left) / r.width);
      });
      this.seek.addEventListener('keydown', function (e) {
        var dur = self.dur || 0;
        if (!dur) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); self.seekTo(Math.min(1, (self.t + 5) / dur)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.seekTo(Math.max(0, (self.t - 5) / dur)); }
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); self.toggle(); }
      });
    }
  };

  function initPlayers() {
    document.querySelectorAll('[data-kb-player]').forEach(function (root) {
      if (root.__kbPlayer) return;
      root.__kbPlayer = new Player(root);
      players.push(root.__kbPlayer);
    });
    // remove players cujo DOM foi trocado pelo editor
    players = players.filter(function (p) { return document.body.contains(p.root); });
  }

  /* ---------- Parallax (hero) ---------- */
  var parBound = false, raf = null;
  function parallaxTick() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      document.querySelectorAll('[data-kb-parallax]').forEach(function (el) {
        var host = el.parentElement.getBoundingClientRect();
        var prog = (host.top + host.height / 2 - window.innerHeight / 2) / window.innerHeight;
        el.style.transform = 'translate3d(0,' + (prog * -9).toFixed(2) + '%,0)';
      });
    });
  }
  function initParallax() {
    if (!document.querySelector('[data-kb-parallax]')) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!parBound) {
      parBound = true;
      window.addEventListener('scroll', parallaxTick, { passive: true });
      window.addEventListener('resize', parallaxTick);
    }
    parallaxTick();
  }

  /* ---------- Gráfico: desenha a linha ao entrar na tela ---------- */
  var io = null;
  function initCharts() {
    var els = document.querySelectorAll('[data-kb-chart]:not(.is-armed)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-armed', 'in'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.15 });
    }
    els.forEach(function (e) { e.classList.add('is-armed'); io.observe(e); });
  }

  function init() { initPlayers(); initParallax(); initCharts(); }
  window.__kbMediaInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
  document.addEventListener('shopify:section:unload', function () { players.forEach(function (p) { p.stop(); }); });
})();
